import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type ShopifyFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const ShopifyFilled = ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }: ShopifyFilledProps) =>
  h(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      fill: color,
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      color,
      "stroke-width": strokeWidth,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'translate(-2.982489 -2.507334) scale(1.447143)',
        },
        [
          h(
            'path',
            {
              d: 'M15.5996 5.17732C15.5884 5.09719 15.5202 5.0515 15.4629 5.0515C15.4056 5.0515 14.1868 4.96045 14.1868 4.96045C14.1868 4.96045 13.3438 4.11744 13.2415 4.02638C13.1501 3.93533 12.9679 3.95784 12.8994 3.98068C12.8882 3.98068 12.7173 4.03765 12.421 4.12903C12.1362 3.29727 11.6349 2.5453 10.7575 2.5453H10.678C10.4386 2.22613 10.1197 2.07812 9.85749 2.07812C7.80692 2.07812 6.82716 4.64159 6.51956 5.94053C5.72158 6.19119 5.15207 6.36205 5.08386 6.38455C4.63951 6.5213 4.62826 6.5329 4.5713 6.95407C4.5256 7.27326 3.3634 16.2742 3.3634 16.2742L12.421 17.9715L17.3313 16.9119C17.3313 16.9006 15.6112 5.25679 15.5996 5.17732ZM11.9197 4.26512C11.664 4.34103 11.4096 4.42084 11.1564 4.50451V4.33366C11.1564 3.83235 11.0879 3.4221 10.9743 3.09199C11.4299 3.16019 11.726 3.67275 11.9197 4.26512ZM10.4045 3.20556C10.5297 3.52474 10.6098 3.96911 10.6098 4.5843V4.67537C10.1081 4.83495 9.57273 4.99455 9.02574 5.1654C9.33368 3.99195 9.91444 3.4221 10.4045 3.20556ZM9.8002 2.62513C9.89126 2.62513 9.98233 2.65922 10.0624 2.71617C9.40155 3.02378 8.70654 3.79858 8.4102 5.35943C7.97744 5.49618 7.55594 5.62134 7.15694 5.74683C7.49899 4.56178 8.33041 2.62513 9.8002 2.62513Z',
            },
          ),
          h(
            'path',
            {
              d: 'M15.4628 5.03944C15.4059 5.03944 14.1867 4.94838 14.1867 4.94838C14.1867 4.94838 13.3437 4.10538 13.2414 4.01399C13.2086 3.97938 13.1636 3.95895 13.1159 3.95703L12.4325 17.9707L17.3429 16.9111C17.3429 16.9111 15.6224 5.25599 15.6112 5.17652C15.6011 5.14243 15.582 5.11169 15.5559 5.08756C15.5298 5.06344 15.4976 5.04681 15.4628 5.03944Z',
              fill: color,
            },
          ),
          h(
            'path',
            {
              d: 'M10.7578 7.75164L10.1538 9.55188C10.1538 9.55188 9.61842 9.26712 8.96878 9.26712C8.01188 9.26712 7.96618 9.87074 7.96618 10.0187C7.96618 10.8392 10.1085 11.1584 10.1085 13.0839C10.1085 14.599 9.15123 15.5788 7.85228 15.5788C6.29142 15.5788 5.50537 14.6103 5.50537 14.6103L5.92687 13.2319C5.92687 13.2319 6.74736 13.9381 7.43078 13.9381C7.88672 13.9381 8.06884 13.5851 8.06884 13.3229C8.06884 12.2521 6.31427 12.2064 6.31427 10.4406C6.31427 8.95953 7.37383 7.52382 9.52704 7.52382C10.3475 7.51257 10.7578 7.75164 10.7578 7.75164H10.7578Z',
              fill: secondaryColor,
            },
          ),
        ],
      ),
    ],
  );

export default ShopifyFilled;
